import { render } from "./UnusableChoices.vue?vue&type=template&id=47279f8c&scoped=true"
import script from "./UnusableChoices.vue?vue&type=script&lang=js"
export * from "./UnusableChoices.vue?vue&type=script&lang=js"

import "./UnusableChoices.vue?vue&type=style&index=0&id=47279f8c&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47279f8c"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
